
import { Check, Sparkles } from "lucide-react";

const benefits = [
  {
    id: "time",
    title: "Économisez plus de 10 heures par semaine",
    description:
      "Automatisez votre création de contenu et processus de planification pour libérer du temps précieux pour la stratégie et la créativité.",
  },
  {
    id: "engagement",
    title: "Augmentez l'engagement de 43%",
    description:
      "Le contenu optimisé par l'IA et les calendriers de publication vous aident à atteindre votre audience quand elle est la plus active.",
  },
  {
    id: "consistency",
    title: "Maintenez une parfaite cohérence",
    description:
      "Gardez la voix de votre marque cohérente sur toutes les plateformes avec l'assistance IA qui apprend votre style.",
  },
  {
    id: "growth",
    title: "Développez votre présence sociale",
    description:
      "Gérez facilement la croissance sur plusieurs plateformes sans avoir besoin d'agrandir votre équipe.",
  },
];

const BenefitsSection = () => {
  return (
    <section id="benefits" className="relative bg-gradient-to-b from-white via-indigo-50/30 to-white py-28 overflow-hidden">
      {/* Éléments décoratifs */}
      <div className="absolute top-0 left-0 w-full h-full overflow-hidden pointer-events-none">
        <div className="absolute -top-24 -right-24 w-96 h-96 bg-purple-200/40 rounded-full filter blur-3xl opacity-30"></div>
        <div className="absolute top-1/3 -left-24 w-72 h-72 bg-indigo-200/50 rounded-full filter blur-3xl opacity-40"></div>
        <div className="absolute -bottom-24 right-1/4 w-80 h-80 bg-blue-200/40 rounded-full filter blur-3xl opacity-30"></div>
      </div>
      
      <div className="container px-4 sm:px-6 lg:px-8 relative z-10">
        <div className="mx-auto max-w-7xl">
          <div className="lg:grid lg:grid-cols-12 lg:gap-16 items-center">
            <div className="lg:col-span-5">
              <div className="inline-flex items-center px-3 py-1.5 rounded-full bg-gradient-to-r from-indigo-500/10 to-purple-500/10 border border-indigo-200">
                <Sparkles className="h-4 w-4 mr-2 text-indigo-600" />
                <span className="text-xs font-semibold text-indigo-600">Résultats Concrets</span>
              </div>
              
              <h2 className="mt-6 text-3xl md:text-4xl font-bold tracking-tight bg-gradient-to-br from-indigo-800 via-indigo-700 to-purple-700 bg-clip-text text-transparent">
                Transformez votre flux de travail sur les réseaux sociaux
              </h2>
              
              <p className="mt-4 text-lg text-gray-600">
                Nos clients constatent des améliorations spectaculaires en termes d'efficacité et de performance après avoir implémenté Scaloo.
              </p>

              <div className="mt-12 space-y-6">
                {benefits.map((benefit) => (
                  <div key={benefit.id} className="group flex items-start p-4 rounded-xl transition-all duration-300 hover:bg-white hover:shadow-xl hover:shadow-indigo-100/60">
                    <div className="flex-shrink-0">
                      <div className="flex h-10 w-10 items-center justify-center rounded-lg bg-gradient-to-br from-indigo-500 to-purple-600 text-white shadow-lg shadow-indigo-200/50 group-hover:shadow-indigo-300/60 transition-all duration-300">
                        <Check className="h-5 w-5" />
                      </div>
                    </div>
                    <div className="ml-4">
                      <h3 className="text-lg font-semibold text-gray-900 group-hover:text-indigo-700 transition-colors duration-300">
                        {benefit.title}
                      </h3>
                      <p className="mt-2 text-gray-600 group-hover:text-gray-700 transition-colors duration-300">
                        {benefit.description}
                      </p>
                    </div>
                  </div>
                ))}
              </div>
            </div>

            <div className="mt-16 lg:col-span-7 lg:mt-0">
              <div className="relative rounded-2xl bg-white p-2 shadow-2xl shadow-indigo-200/50 border border-indigo-100/50 transform hover:rotate-1 transition-all duration-500">
                <div className="absolute inset-0 bg-gradient-to-tr from-indigo-100 to-transparent opacity-40 rounded-2xl"></div>
                
                <div className="relative aspect-[4/3] overflow-hidden rounded-xl shadow-inner">
                  <img
                    src="https://images.unsplash.com/photo-1600267204091-5c1ab8b10c02?ixlib=rb-1.2.1&auto=format&fit=crop&w=2070&q=80"
                    alt="Interface moderne de gestion des réseaux sociaux avec visualisations de données"
                    className="h-full w-full object-cover hover:scale-105 transition-transform duration-700"
                  />
                  
                  <div className="absolute inset-0 bg-gradient-to-t from-indigo-900/20 to-transparent"></div>
                </div>
                
                {/* Éléments décoratifs */}
                <div className="absolute -bottom-3 -right-3 w-24 h-24 bg-purple-200 rounded-full filter blur-xl opacity-60 animate-pulse"></div>
                <div className="absolute -top-4 -left-4 w-20 h-20 bg-indigo-200 rounded-full filter blur-xl opacity-60"></div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default BenefitsSection;
